
export default class Coalesce {
    static array<T>(incomingArray: T[]): T[] {
        return incomingArray ? incomingArray : [];
    }

    static singleValue<T>(incoming: T, defaultFactory: () => T): T {
        return incoming ? incoming : defaultFactory();
    }
}